import Immutable from 'seamless-immutable'
import {
  WALLET_CLEAR_FILTERS,
  WALLET_LIST_FETCHING,
  WALLET_LIST_SUCCESS,
  WALLET_RECEIVE_FILTERS
} from './types'

export const INITIAL_STATE = Immutable({
  fetching: false,
  wallets: [],
  pagination: {
    currentPage: 1,
    lastPage: 1,
    total: 0
  },
  hasFilters: false,
  filters: {
    page: 1,
    perPage: 15,
    storeStatus: [],
    storeGroups: [],
    products: [],
    networkCodes: [],
    subsidiaryCodes: [],
    partnerStdCodes: [],
    priorityMatrices: [],
    segments: [],
    subsegments: [],
    orderBy: 'production',
    search: undefined,
    orderByDirection: 'desc'
  }
})

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WALLET_LIST_FETCHING: {
      return {
        ...state,
        loading: true
      }
    }
    case WALLET_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        wallets: action.payload.increment
          ? [...state.wallets, ...action.payload.data]
          : action.payload.data,
        pagination: action.payload.pagination,
        filters: {
          ...state.filters,
          page: action.payload.pagination.currentPage
        }
      }
    }

    case WALLET_RECEIVE_FILTERS: {
      return {
        ...state,
        hasFilters: true,
        filters: {
          ...state.filters,
          ...action.payload
        }
      }
    }

    case WALLET_CLEAR_FILTERS: {
      return {
        ...state,
        hasFilters: false,
        filters: {
          ...INITIAL_STATE.filters
        }
      }
    }

    default:
      return state
  }
}

export default reducer
